import React, { useContext, useMemo, useRef, useState } from "react";
import { useUpdateEffect } from "ahooks";

export const CompanyDevicesContext = React.createContext({});
export const CompanyDevicesActionContext = React.createContext({});

export const useGroupDeviceState = () => {
  return useContext(CompanyDevicesContext);
};

export const useGroupDeviceDispatch = () => {
  return useContext(CompanyDevicesActionContext);
};

function getLocalStorage(name, defaultState) {
  const lastState = localStorage.getItem(name);
  if (lastState) {
    return JSON.parse(lastState);
  }
  return defaultState;
}

export function getIntialGroupState() {
  // const lastGroupState = getLocalStorage("__lastCompanyDeviceState", {
  //   loadingGroup: true,
  //   reloadTreeFlag: 0
  // });
  const lastCheckable = getLocalStorage("__lastCheckable")
  const lastGroupState = {
    currentGroup: null,
    loadingGroup: true,
    checkable: lastCheckable, // 是否多选
    reloadTreeFlag: false
  };
  return lastGroupState;
}

export default ({ children }) => {
  const [state, setCurrentState] = useState(getIntialGroupState);

  const lastCheckable = useRef(
    getLocalStorage("__lastCheckable")
  )
  const lastSingleSelectedGroup = useRef(
    getLocalStorage("__lastSelectCompanyDeviceState")
  );

  const action = useMemo(() => {
    return {
      // 设置单选多选
      setCheckable: (status) => {
        localStorage.setItem("__lastCheckable",status)
      },
      setCurrentGroup: (info, resetTag) => {
        lastSingleSelectedGroup.current = info;
        setCurrentState(preState => ({
          ...preState,
          loadingGroup: false,
          currentGroup: info,
        }));
        requestAnimationFrame(() => {
          localStorage.setItem("__lastSelectCompanyDeviceState", JSON.stringify(info));
        });
      },
      updateCurrentGroup: info => {
        setCurrentState(preState => ({
          ...preState,
          currentGroup: { ...preState.currentGroup, ...info },
        }));
      },
      resetCurrentGroup: (clear, callback) => {
        setCurrentState(preState => {
          const newState = {
            ...preState,
            currentGroup: clear ? null : lastSingleSelectedGroup.current,
          };
          callback?.(newState);
          return newState;
        });
      },
      setLoadingGroup: bool => {
        setCurrentState(preState => ({
          ...preState,
          loadingGroup: bool
        }));
      },
      reloadCategoryTree: () => {
        setCurrentState(preState => ({
          ...preState,
          reloadTreeFlag: preState.reloadTreeFlag + 1
        }));
      }
    };
  }, []);

  useUpdateEffect(() => {
    requestAnimationFrame(() => {
      localStorage.setItem("__lastCompanyDeviceState", JSON.stringify(state));
    });
  }, [state]);

  return (
    <CompanyDevicesContext.Provider value={state}>
      <CompanyDevicesActionContext.Provider value={action}>
        {children}
      </CompanyDevicesActionContext.Provider>
    </CompanyDevicesContext.Provider>
  );
};
